import Model from '@/lib/data/Model';

class VisitQraCnle extends Model {
    fields = [
        {
            name: 'loss_estimate_value',
        },
    ];

    constructor(data) {
        super(data);
        this.init();
    }

    api = [
        {
            name: 'read',
            url: '/visit/riskimprovement/getcnle',
            params: ['visit_id'],
        },
    ];
}

export default VisitQraCnle;
